import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import "../../styles/TitleLine.css";

const TitleLineNoLink = ({ title, link, onLinkClick }) => {
  return (
    <Container className="titleline-container-nolink">
      <Row className="titleline-row">
        <Col xs={12}>
          <h2 className="titleline-title">{title}</h2>
        </Col>
      </Row>
      <Row>
        <Col className="titleline-divider-wrapper">
          <div className="titleline-divider"></div>
        </Col>
      </Row>
    </Container>
  );
};

export default TitleLineNoLink;
